import { lazy, Suspense } from "react";

// Url
import url from "url/index";

// const LazyJackpotPage = lazy(() => import("components/pages/Casino/Jackpot"));
const LazyAccountPage = lazy(() => import("components/pages/Profile/Account"));
const LazyTransactionHistoryPage = lazy(
  () => import("components/pages/Profile/TransactionHistory"),
);
const LazyGameHistoryPage = lazy(
  () => import("components/pages/Profile/GameHistory"),
);
const LazyAchievementPage = lazy(
  () => import("components/pages/Profile/Achievement"),
);
const LazyBonusPage = lazy(() => import("components/pages/Profile/Bonus"));
const LazyLoyaltyPage = lazy(() => import("components/pages/Profile/Loyalty"));
const LazyCashbackPage = lazy(
  () => import("components/pages/Profile/Cashback"),
);
const LazyInviteFriendPage = lazy(
  () => import("components/pages/Profile/InviteFriend"),
);
const LazyNotificationPage = lazy(
  () => import("components/pages/Profile/Notification"),
);
const LazyPesonalPage = lazy(() => import("components/pages/Profile/Pesonal"));
const LazyTournamentPage = lazy(
  () => import("components/pages/Tournament/TournamentPage"),
);
const LazyWheelPage = lazy(() => import("components/pages/Landing/Wheels"));
const LazyEmptyPage = lazy(() => import("components/pages/Landing/EmptyPage"));
const LazyBannedPage = lazy(
  () => import("components/pages/StaticPages/AccountBlockedPage"),
);
const LazyAboutPage = lazy(() => import("components/pages/Info/About"));
const LazyConditionsPage = lazy(
  () => import("components/pages/Info/Conditions"),
);
const LazyKycAmlPage = lazy(() => import("components/pages/Info/KycAml"));
const LazyPrivacyPage = lazy(() => import("components/pages/Info/Privacy"));
const LazyCookiesPage = lazy(() => import("components/pages/Info/Cookies"));
const LazyGamblePage = lazy(() => import("components/pages/Info/Gamble"));
const LazySupportPage = lazy(() => import("components/pages/Info/Support"));
const LazyWelcomeBonusPage = lazy(
  () => import("components/pages/Info/WelcomeBonus"),
);
const LazyNotAvaliablePage = lazy(
  () => import("components/pages/StaticPages/NotAvailablePage"),
);
const LazyAviatorLandingPage = lazy(
  () => import("components/pages/Landing/Aviator"),
);
const LazyGamePageContainer = lazy(
  () => import("containers/pages/GamePageContainer"),
);
const LazyCoinStrikeLandingPage = lazy(
  () => import("components/pages/Landing/CoinStrike"),
);

const LazyHomePageContainer = lazy(
  () => import("containers/pages/HomePageContainer"),
);
const LazyTournamentsPageContainer = lazy(
  () => import("containers/pages/TournamentsPageContainer"),
);
const LazyCoinFestPageContainer = lazy(
  () => import("containers/pages/CoinFestPageContainer"),
);
const LazyFavoritePageContainer = lazy(
  () => import("containers/pages/FavoritePageContainer"),
);
const LazyErrorPageContainer = lazy(
  () => import("containers/pages/ErrorPageContainer"),
);
const LazySportsBookPageContainer = lazy(
  () => import("containers/pages/SportsBookContainer"),
);
// const LazyLoyalty = lazy(() => import("components/layouts/LoyaltyLayout"));
// const LazyLoyaltyNonAuth = lazy(
//   () => import("components/pages/Info/LoyaltyProgram"),
// );
const LazyLoyalty = lazy(() => import("components/layouts/LoyaltyLayout"));
const LazyLoyaltyRules = lazy(
  () => import("components/pages/Profile/LoyaltyRules"),
);
const LazyLoyaltyRanks = lazy(
  () => import("components/pages/Profile/LoyaltyRanks"),
);
const LazyPersonal = lazy(
  () => import("components/pages/Profile/PersonalMobile"),
);

export enum PAGES {
  HOME,
  FAVORITE,
  POPULAR,
  CATEGORY,
  TOURNAMENTS,
  JACKPOT,
  GAME_PAGE,
  PROFILE,
  PROFILE_SAFETY,
  PROFILE_PERSONAL_DATA,
  TRANSACTIONS_HISTORY,
  TRANSACTIONS_HISTORY_DEPOSIT,
  TRANSACTIONS_HISTORY_WITHDRAWAL,
  GAMES_HISTORY,
  ACHIEVEMENTS,
  BONUSES,
  LOYALTY_PROGRAM,
  LOYALTY_PROGRAM_RULES,
  LOYALTY_PROGRAM_RANKS,
  LOYALTY_RANKS_PROGRAM,
  LOYALTY_AVATAR_PROGRAM,
  LOYALTY_HELP_PROGRAM,
  CASHBACK,
  INVITE_FRIEND,
  NOTIFICATION,
  TOURNAMENT,
  TOURNAMENTID,
  LANDING,
  GIRLS,
  GIRLS_BANGLADESH,
  TEENAGERS,
  CARDS,
  AVIATOR,
  COIN_STRIKE,
  CHICKS_TURKEY,
  CHICKS_BANGLADESH,
  CHICKS_UZBEKISTAN,
  CHICKS_AZER,
  CRAZY_TIME,
  PROFILE_BLOCKED,
  INFO,
  PROMO,
  ABOUT,
  CONDITIONS,
  KYCAML,
  PRIVACY,
  GAMBLE,
  COOKIES,
  SUPPORT,
  WELCOME_BONUS,
  SERVICE_ERROR,
  NOT_AVAILABLE,
  COIN_FEST,
  LANDING_AVIATOR,
  LANDING_ROULETTE,
  NEW_GLORY,
  SWEET_BONANZA,
  GATES_OLYMPUS,
  LOYALTY,
  LOYALTY_NON_AUTH,
  PERSONAL_DATA,
  SPORTSBOOK,
}

type RouteListType = {
  id: number;
  url: string;
  page: JSX.Element;
};

export const CASINO_ROUTES: RouteListType[] = [
  {
    id: PAGES.HOME,
    url: url.routes.casino.index(),
    page: (
      <Suspense fallback="Loading">
        <LazyHomePageContainer />
      </Suspense>
    ),
  },
  {
    id: PAGES.POPULAR,
    url: url.routes.casino.index(),
    page: (
      <Suspense fallback="Loading">
        <LazyHomePageContainer />
      </Suspense>
    ),
  },
  {
    id: PAGES.CATEGORY,
    url: url.config.casino.category,
    page: (
      <Suspense fallback="Loading">
        <LazyHomePageContainer />
      </Suspense>
    ),
  },
  {
    id: PAGES.GAME_PAGE,
    url: url.config.casino.game,
    page: (
      <Suspense fallback="Loading">
        <LazyGamePageContainer />
      </Suspense>
    ),
  },
  {
    id: PAGES.FAVORITE,
    url: url.routes.casino.favorites(),
    page: (
      <Suspense fallback="Loading">
        <LazyFavoritePageContainer />
      </Suspense>
    ),
  },

  {
    id: PAGES.SPORTSBOOK,
    url: url.routes.casino.sportBook(),
    page: (
      <Suspense fallback="Loading">
        <LazySportsBookPageContainer />
      </Suspense>
    ),
  },
];

export const PROFILE_ROUTES: RouteListType[] = [
  {
    id: PAGES.PROFILE,
    url: url.config.profile.root,
    page: (
      <Suspense fallback="Loading">
        <LazyAccountPage />
      </Suspense>
    ),
  },
  {
    id: PAGES.PERSONAL_DATA,
    url: url.config.profile.personalInfo,
    page: (
      <Suspense fallback="Loading">
        <LazyPersonal />
      </Suspense>
    ),
  },
  {
    id: PAGES.PROFILE,
    url: url.routes.profile.index(),
    page: (
      <Suspense fallback="Loading">
        <LazyAccountPage />
      </Suspense>
    ),
  },
  {
    id: PAGES.PROFILE_PERSONAL_DATA,
    url: url.config.profile.personal,
    page: (
      <Suspense fallback="Loading">
        <LazyPesonalPage />
      </Suspense>
    ),
  },
  {
    id: PAGES.TRANSACTIONS_HISTORY,
    url: url.config.profile.transactionHistory.root,
    page: (
      <Suspense fallback="Loading">
        <LazyTransactionHistoryPage />
      </Suspense>
    ),
  },
  {
    id: PAGES.TRANSACTIONS_HISTORY_DEPOSIT,
    url: url.config.profile.transactionHistory.deposit,
    page: (
      <Suspense fallback="Loading">
        <LazyTransactionHistoryPage />
      </Suspense>
    ),
  },
  {
    id: PAGES.TRANSACTIONS_HISTORY_WITHDRAWAL,
    url: url.config.profile.transactionHistory.withdrawal,
    page: (
      <Suspense fallback="Loading">
        <LazyTransactionHistoryPage />
      </Suspense>
    ),
  },
  {
    id: PAGES.GAMES_HISTORY,
    url: url.config.profile.gamesHistory,
    page: (
      <Suspense fallback="Loading">
        <LazyGameHistoryPage />
      </Suspense>
    ),
  },
  {
    id: PAGES.ACHIEVEMENTS,
    url: url.config.profile.achievements,
    page: (
      <Suspense fallback="Loading">
        <LazyAchievementPage />
      </Suspense>
    ),
  },
  {
    id: PAGES.BONUSES,
    url: url.config.profile.bonus,
    page: (
      <Suspense fallback="Loading">
        <LazyBonusPage />
      </Suspense>
    ),
  },
  {
    id: PAGES.LOYALTY_PROGRAM,
    url: url.config.profile.loyaltyProgram.root,
    page: (
      <Suspense fallback="Loading">
        <LazyLoyaltyPage />
      </Suspense>
    ),
  },
  {
    id: PAGES.LOYALTY_PROGRAM_RULES,
    url: url.config.profile.loyaltyProgram.rules,
    page: (
      <Suspense fallback="Loading">
        <LazyLoyaltyRules />
      </Suspense>
    ),
  },
  {
    id: PAGES.LOYALTY_PROGRAM_RANKS,
    url: url.config.profile.loyaltyProgram.ranks,
    page: (
      <Suspense fallback="Loading">
        <LazyLoyaltyRanks />
      </Suspense>
    ),
  },
  {
    id: PAGES.CASHBACK,
    url: url.config.profile.cashback,
    page: (
      <Suspense fallback="Loading">
        <LazyCashbackPage />
      </Suspense>
    ),
  },
  {
    id: PAGES.INVITE_FRIEND,
    url: url.config.profile.inviteFriend,
    page: (
      <Suspense fallback="Loading">
        <LazyInviteFriendPage />
      </Suspense>
    ),
  },
  {
    id: PAGES.NOTIFICATION,
    url: url.config.profile.notification.root,
    page: (
      <Suspense fallback="Loading">
        <LazyNotificationPage />
      </Suspense>
    ),
  },
  {
    id: PAGES.LOYALTY,
    url: url.config.profile.loyaltyProgram.root,
    page: (
      <Suspense fallback="Loading">
        <LazyLoyalty />
      </Suspense>
    ),
  },
];

export const COIN_FEST_ROUTES: RouteListType[] = [
  {
    id: PAGES.COIN_FEST,
    url: url.routes.coinFest.index(),
    page: (
      <Suspense fallback="Loading">
        <LazyCoinFestPageContainer />
      </Suspense>
    ),
  },
];

export const TOURNAMENT_ROUTES: RouteListType[] = [
  {
    id: PAGES.TOURNAMENT,
    url: url.routes.tournament.index(),
    page: (
      <Suspense fallback="Loading">
        <LazyTournamentsPageContainer />
      </Suspense>
    ),
  },

  {
    id: PAGES.TOURNAMENTID,
    url: url.config.tournament.tournamentId,
    page: (
      <Suspense fallback="Loading">
        <LazyTournamentPage />
      </Suspense>
    ),
  },
];

export const LANDING_ROUTES: RouteListType[] = [
  {
    id: PAGES.LANDING,
    url: url.routes.landing.index(),
    page: (
      <Suspense fallback="">
        <LazyEmptyPage />
      </Suspense>
    ),
  },
  {
    id: PAGES.LANDING_AVIATOR,
    url: url.config.landing.aviator,
    page: (
      <Suspense fallback="">
        <LazyAviatorLandingPage />
      </Suspense>
    ),
  },
  {
    id: PAGES.COIN_STRIKE,
    url: url.config.landing.cointStrike,
    page: (
      <Suspense fallback="">
        <LazyCoinStrikeLandingPage />
      </Suspense>
    ),
  },
  {
    id: PAGES.GIRLS,
    url: url.config.landing.wheels.girls,
    page: (
      <Suspense fallback="">
        <LazyWheelPage
          pathname={`/${url.config.landing.root}/${url.config.landing.wheels.girls}`}
        />
      </Suspense>
    ),
  },
  {
    id: PAGES.GIRLS_BANGLADESH,
    url: url.config.landing.wheels.girlsBangladesh,
    page: (
      <Suspense fallback="">
        <LazyWheelPage
          pathname={`/${url.config.landing.root}/${url.config.landing.wheels.girlsBangladesh}`}
        />
      </Suspense>
    ),
  },
  {
    id: PAGES.TEENAGERS,
    url: url.config.landing.wheels.teenagers,
    page: (
      <Suspense fallback="">
        <LazyWheelPage
          pathname={`/${url.config.landing.root}/${url.config.landing.wheels.teenagers}`}
        />
      </Suspense>
    ),
  },
  {
    id: PAGES.CARDS,
    url: url.config.landing.wheels.cards,
    page: (
      <Suspense fallback="">
        <LazyWheelPage
          pathname={`/${url.config.landing.root}/${url.config.landing.wheels.cards}`}
        />
      </Suspense>
    ),
  },
  {
    id: PAGES.AVIATOR,
    url: url.config.landing.wheels.aviator,
    page: (
      <Suspense fallback="">
        <LazyWheelPage
          pathname={`/${url.config.landing.root}/${url.config.landing.wheels.aviator}`}
        />
      </Suspense>
    ),
  },
  {
    id: PAGES.CHICKS_TURKEY,
    url: url.config.landing.wheels.chicksTurkey,
    page: (
      <Suspense fallback="">
        <LazyWheelPage
          pathname={`/${url.config.landing.root}/${url.config.landing.wheels.chicksTurkey}`}
        />
      </Suspense>
    ),
  },
  {
    id: PAGES.CHICKS_BANGLADESH,
    url: url.config.landing.wheels.chicksBangladesh,
    page: (
      <Suspense fallback="">
        <LazyWheelPage
          pathname={`/${url.config.landing.root}/${url.config.landing.wheels.chicksBangladesh}`}
        />
      </Suspense>
    ),
  },
  {
    id: PAGES.CHICKS_UZBEKISTAN,
    url: url.config.landing.wheels.chicksUzbekistan,
    page: (
      <Suspense fallback="">
        <LazyWheelPage
          pathname={`/${url.config.landing.root}/${url.config.landing.wheels.chicksUzbekistan}`}
        />
      </Suspense>
    ),
  },
  {
    id: PAGES.CHICKS_AZER,
    url: url.config.landing.wheels.chicksAzer,
    page: (
      <Suspense fallback="">
        <LazyWheelPage
          pathname={`/${url.config.landing.root}/${url.config.landing.wheels.chicksAzer}`}
        />
      </Suspense>
    ),
  },
  {
    id: PAGES.CRAZY_TIME,
    url: url.config.landing.wheels.crazyTime,
    page: (
      <Suspense fallback="">
        <LazyWheelPage
          pathname={`/${url.config.landing.root}/${url.config.landing.wheels.crazyTime}`}
        />
      </Suspense>
    ),
  },
  {
    id: PAGES.LANDING_ROULETTE,
    url: url.config.landing.wheels.roulette,
    page: (
      <Suspense fallback="">
        <LazyWheelPage
          pathname={`/${url.config.landing.root}/${url.config.landing.wheels.roulette}`}
        />
      </Suspense>
    ),
  },
  {
    id: PAGES.SWEET_BONANZA,
    url: url.config.landing.wheels.sweetBonanza,
    page: (
      <Suspense fallback="">
        <LazyWheelPage
          pathname={`/${url.config.landing.root}/${url.config.landing.wheels.sweetBonanza}`}
        />
      </Suspense>
    ),
  },
  {
    id: PAGES.GATES_OLYMPUS,
    url: url.config.landing.wheels.gatesOlympus,
    page: (
      <Suspense fallback="">
        <LazyWheelPage
          pathname={`/${url.config.landing.root}/${url.config.landing.wheels.gatesOlympus}`}
        />
      </Suspense>
    ),
  },
];

export const PAGES_ROUTES: RouteListType[] = [
  {
    id: PAGES.SERVICE_ERROR,
    url: url.config.pages.serviceError,
    page: (
      <Suspense fallback="Loading">
        <LazyErrorPageContainer />
      </Suspense>
    ),
  },
  {
    id: PAGES.NOT_AVAILABLE,
    url: url.config.pages.notAvailablePage,
    page: (
      <Suspense fallback="Loading">
        <LazyNotAvaliablePage />
      </Suspense>
    ),
  },
  {
    id: PAGES.PROFILE_BLOCKED,
    url: url.config.pages.banned,
    page: (
      <Suspense fallback="Loading">
        <LazyBannedPage />
      </Suspense>
    ),
  },
];

export const INFO_ROUTES: RouteListType[] = [
  {
    id: PAGES.INFO,
    url: url.routes.info.index(),
    page: (
      <Suspense fallback="Loading">
        <LazyEmptyPage />
      </Suspense>
    ),
  },
  {
    id: PAGES.ABOUT,
    url: url.config.info.about,
    page: (
      <Suspense fallback="Loading">
        <LazyAboutPage />
      </Suspense>
    ),
  },
  {
    id: PAGES.CONDITIONS,
    url: url.config.info.conditions,
    page: (
      <Suspense fallback="Loading">
        <LazyConditionsPage />
      </Suspense>
    ),
  },
  {
    id: PAGES.KYCAML,
    url: url.config.info.kycaml,
    page: (
      <Suspense fallback="Loading">
        <LazyKycAmlPage />
      </Suspense>
    ),
  },
  {
    id: PAGES.PRIVACY,
    url: url.config.info.privacy,
    page: (
      <Suspense fallback="Loading">
        <LazyPrivacyPage />
      </Suspense>
    ),
  },
  {
    id: PAGES.GAMBLE,
    url: url.config.info.responsiblegame,
    page: (
      <Suspense fallback="Loading">
        <LazyGamblePage />
      </Suspense>
    ),
  },
  {
    id: PAGES.COOKIES,
    url: url.config.info.cookies,
    page: (
      <Suspense fallback="Loading">
        <LazyCookiesPage />
      </Suspense>
    ),
  },
  {
    id: PAGES.SUPPORT,
    url: url.config.info.support,
    page: (
      <Suspense fallback="Loading">
        <LazySupportPage />
      </Suspense>
    ),
  },
  {
    id: PAGES.WELCOME_BONUS,
    url: url.config.info.welcomeBonus,
    page: (
      <Suspense fallback="Loading">
        <LazyWelcomeBonusPage />
      </Suspense>
    ),
  },
  // На время тестирования на проде первых пользователей пока нинадо
  // {
  //   id: PAGES.LOYALTY_NON_AUTH,
  //   url: url.config.info.loyaltyProgram,
  //   page: (
  //     <Suspense fallback="Loading">
  //       <LazyLoyaltyNonAuth />
  //     </Suspense>
  //   ),
  // },
];

export const PROMO_ROUTES: RouteListType[] = [
  {
    id: PAGES.PROMO,
    url: url.routes.promo.index(),
    page: (
      <Suspense fallback="Loading">
        <LazyEmptyPage />
      </Suspense>
    ),
  },
];
